// extracted by mini-css-extract-plugin
export default {"poweredByAuthencity":"styles_poweredByAuthencity__1wjSt","poweredByAuthencity_w100":"styles_poweredByAuthencity_w100__TfJGT"};